<template>
  <b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
    <div>
      <CRow>
        <CCol>
          <label for="user-select">Zaposleni</label>
          <b-form-select
              v-model="modalWorkingTimeSetup.user_id"
              :options="userOptions"
              id="user-select">
            <template #first>
              <b-form-select-option :value="null">Velja za sve zaposlene</b-form-select-option>
            </template>
          </b-form-select>
        </CCol>
      </CRow>

      <CAlert color="info" class="mt-3 mb-3" style="font-size: 0.9em;">
        <strong>Opomba:</strong>
        Nastavitve za posameznega zaposlenega imajo prednost pred splošnimi nastavitvami (kjer zaposleni ni izbran).
      </CAlert>

      <hr/>
      <div v-for="day in daysConfig" :key="day.key" class="mb-2">
        <b-row align-v="center">
          <b-col cols="4">
            <b-form-checkbox v-model="modalWorkingTimeSetup[day.key + '_enabled']">
              {{ day.label }}
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <CInput
                size="sm"
                type="time"
                v-model="modalWorkingTimeSetup[day.key + '_start']"
                :disabled="!modalWorkingTimeSetup[day.key + '_enabled']"
                placeholder="Začetek"
            />
          </b-col>
          <b-col cols="4">
            <CInput
                size="sm"
                type="time"
                v-model="modalWorkingTimeSetup[day.key + '_end']"
                :disabled="!modalWorkingTimeSetup[day.key + '_enabled']"
                placeholder="Konec"
            />
          </b-col>
        </b-row>
      </div>

      <CAlert color="warning" class="mt-3 mb-3" style="font-size: 0.9em;">
        <strong>Pomembno:</strong>
        Če je praznik nastavljen, bodo njegovi delovni časi veljavni za praznik ne glede na dan v tednu. Primer: če je
        za ponedeljek nastavljen 08:00-16:00, za praznik pa 10:00-14:00, bo na ponedeljek, ki je praznik, veljal čas
        10:00-14:00.
      </CAlert>

      <hr/>

      <CRow class="mt-3">
        <CCol>
          <v-date-picker
              locale="sl-SI"
              v-model="modalWorkingTimeSetup.effective_from"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  label="Velja od"
                  :value="inputValue"
                  v-on="inputEvents"
                  placeholder="Pustite prazno za trajno"/>
            </template>
          </v-date-picker>
        </CCol>
        <CCol>
          <v-date-picker
              locale="sl-SI"
              v-model="modalWorkingTimeSetup.effective_to"
              :model-config=" {
									type: 'string',
								}"
              timezone='utc'>
            <template v-slot="{ inputValue, inputEvents }">
              <CInput
                  label="Velja do"
                  :value="inputValue"
                  v-on="inputEvents"
                  placeholder="Pustite prazno za trajno"/>
            </template>
          </v-date-picker>
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol>
          <CInput
              label="Razlog (opcijsko)"
              v-model="modalWorkingTimeSetup.reason"
              placeholder="Npr. sezonsko, projektno..."/>
        </CCol>
      </CRow>
    </div>
    <CAlert v-show="message.text != null" :color="message.type">
      {{ message.text }}
    </CAlert>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <b-container fluid class="p-0">
        <b-row>
          <b-col align-self="end" class="ma_pos">
            <b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
            <b-button :disabled="okButton.disabled || !isFormValid" :title="isFormValid ? '' : 'Preverite vnos podatkov'" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <vue-loading :active.sync="isLoading" :is-full-page="false"/>
  </b-modal>
</template>

<script>
import { WORKING_TIME_SETUP_CREATE_EDIT } from "@/store/actions/workingTimeSetups";
import UsersService from "@/services/users";

export default {
  name: 'working-time-setup-create-edit-modal',
  components: {
  },
  props: {
  },
  methods: {
    showModal: function (modalInput) {
      /*
        mode 1 => Create
        mode 2 => Edit
      */
      this.mode = modalInput.mode;
      this.loadUsers();
      this.initModal(modalInput.modalWorkingTimeSetup);
    },
    loadUsers: async function () {
      try {
        const requestData = {
          size: 200,
          page: 1,
          sort: '',
          desc: false,
        };
        const responseData = await UsersService.listAll(requestData);
        console.log("responseData", responseData);
        this.userOptions = responseData
            .users
            .filter(user => user.roles.some(role => ['licar', 'klepar'].includes(role.name)))
            .map(user => ({
              value: user.id,
              text: user.name
            }))
            .sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
      } catch (error) {
        console.error('Error loading users:', error);
      }
    },
    initModal: function (modalWorkingTimeSetup) {
      if (this.mode === this.mode_CREATE1) {
        this.title = 'Dodajanje nastavitve delovnega časa';
        this.okButton.label = 'Dodaj';
        // Default values are already set in clearModalData/data
      } else if (this.mode === this.mode_EDIT2) {
        this.title = 'Urejanje nastavitve delovnega časa (#' + modalWorkingTimeSetup.id + ')';
        this.initWorkingTimeSetup(modalWorkingTimeSetup);
        this.okButton.label = 'Shrani';
      } else {
        this.mode = this.mode_UNKNOWN0;
        this.title = 'Neznan način';
        this.okButton.label = 'Zapri';
      }
      this.$refs.modal.show();
    },
    initWorkingTimeSetup: function (modalWorkingTimeSetup) {
      this.modalWorkingTimeSetup.id = modalWorkingTimeSetup.id;
      this.modalWorkingTimeSetup.user_id = modalWorkingTimeSetup.user_id;

      this.daysConfig.forEach(day => {
        this.modalWorkingTimeSetup[day.key + '_enabled'] = !!modalWorkingTimeSetup[day.key + '_enabled'];
        this.modalWorkingTimeSetup[day.key + '_start'] = modalWorkingTimeSetup[day.key + '_start'] || '08:00';
        this.modalWorkingTimeSetup[day.key + '_end'] = modalWorkingTimeSetup[day.key + '_end'] || '16:00';
      });

      this.modalWorkingTimeSetup.effective_from = modalWorkingTimeSetup.effective_from;
      this.modalWorkingTimeSetup.effective_to = modalWorkingTimeSetup.effective_to;
      this.modalWorkingTimeSetup.reason = modalWorkingTimeSetup.reason;
    },
    onOkModal: function () {
      this.startProgress();
      const modalWorkingTimeSetup = this.modalWorkingTimeSetup;
      this.$store.dispatch(WORKING_TIME_SETUP_CREATE_EDIT, { modalWorkingTimeSetup })
          .then((responseData) => {
            this.stopProgress();
            this.$emit('emit_workingTimeSetupCreatedOrEdited', responseData);
            this.$refs.modal.hide();
          })
          .catch(error => {
            this.stopProgress();
            console.error(error);
            let errorMessage = 'Napaka! Prosimo poizkusite kasneje.';

            if(error.response && error.response.data) {
              if (error.response.data.message) {
                // Display the actual error message from backend
                errorMessage = error.response.data.message;
              } else if (error.response.data.code) {
                // Fallback to code if message is not available
                if (this.mode === this.mode_CREATE1) {
                  errorMessage = 'Napaka pri dodajanju! (' + error.response.data.code + ')';
                } else if (this.mode === this.mode_EDIT2) {
                  errorMessage = 'Napaka pri urejanju! (' + error.response.data.code + ')';
                } else {
                  errorMessage = 'Neznan način modala! (' + error.response.data.code + ')';
                }
              }
            }

            this.showAlert(errorMessage, this.ALERT_TYPE_ERROR);
          });
    },
    clearModalData: function () {
      this.isLoading = false;
      this.title = '';
      this.okButton = {
        label: 'Shrani',
        progress: false,
        disabled: false
      };
      this.showAlert();
      this.mode = 0;

      const newSetup = {
        id: 0,
        user_id: null,
        effective_from: null,
        effective_to: null,
        reason: '',
      };

      // Reset days
      this.daysConfig.forEach(day => {
        const isWeekday = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].includes(day.key);
        newSetup[day.key + '_enabled'] = isWeekday;
        newSetup[day.key + '_start'] = '08:00';
        newSetup[day.key + '_end'] = '16:00';
      });

      this.modalWorkingTimeSetup = newSetup;
    },
    startProgress: function () {
      this.isLoading = true;
      this.okButton.disabled = true;
      this.okButton.progress = true;
    },
    stopProgress: function () {
      this.isLoading = false;
      this.okButton.disabled = false;
      this.okButton.progress = false;
    },
    showAlert: function (message, type, seconds) {
      if (message && type && seconds) {
        this.message.type = type;
        this.message.text = message;
        setTimeout(() => {
          this.showAlert();
        }, seconds * 1000);
      } else if (message && type) {
        this.message.type = type;
        this.message.text = message;
      } else if (message) {
        this.message.type = 'primary';
        this.message.text = message;
      } else {
        this.message.type = null;
        this.message.text = null;
      }
    }
  },
  data: function () {
    return {
      isLoading: false,
      title: '',
      okButton: {
        label: 'Shrani',
        progress: false,
        disabled: false
      },
      message: {
        type: null,
        text: null
      },
      ALERT_TYPE_SUCCESS: 'success',
      ALERT_TYPE_ERROR: 'danger',
      mode_UNKNOWN0: 0,
      mode_CREATE1: 1,
      mode_EDIT2: 2,
      mode: 0,
      daysConfig: [
        { key: 'monday', label: 'Ponedeljek' },
        { key: 'tuesday', label: 'Torek' },
        { key: 'wednesday', label: 'Sreda' },
        { key: 'thursday', label: 'Četrtek' },
        { key: 'friday', label: 'Petek' },
        { key: 'saturday', label: 'Sobota' },
        { key: 'sunday', label: 'Nedelja' },
        { key: 'holiday', label: 'Praznik' },
      ],
      modalWorkingTimeSetup: {
        id: 0,
        user_id: null,
        // Days will be populated in created/clearModalData
        effective_from: null,
        effective_to: null,
        reason: '',
      },
      userOptions: [],
    }
  },
  created() {
    this.clearModalData();
  },
  watch: {
  },
  computed: {
    modalSize () {
      return 'lg';
    },
    isFormValid() {
      // Check if at least one day is enabled? Or just check times for enabled days
      let valid = true;
      this.daysConfig.forEach(day => {
        if (this.modalWorkingTimeSetup[day.key + '_enabled']) {
          if (!this.modalWorkingTimeSetup[day.key + '_start'] || !this.modalWorkingTimeSetup[day.key + '_end']) {
            valid = false;
          }
        }
      });
      return valid;
    }
  }
}
</script>

<style scoped>
.ma_pos {
  text-align: end;
}
</style>
